import {
        GETSETUPOPTICDOCWORKPUPILSIZEODRE,
        CREATESETUPOPTICDOCWORKPUPILSIZEODRE,
        UPDATESETUPOPTICDOCWORKPUPILSIZEODRE,
        DELETESETUPOPTICDOCWORKPUPILSIZEODRE,

        GETSETUPOPTICDOCWORKPUPILSHAPEODRE,
        CREATESETUPOPTICDOCWORKPUPILSHAPEODRE,
        UPDATESETUPOPTICDOCWORKPUPILSHAPEODRE,
        DELETESETUPOPTICDOCWORKPUPILSHAPEODRE,

        GETSETUPOPTICDOCWORKPUPILREACTTOLIGHTODRE,
        CREATESETUPOPTICDOCWORKPUPILREACTTOLIGHTODRE,
        UPDATESETUPOPTICDOCWORKPUPILREACTTOLIGHTODRE,
        DELETESETUPOPTICDOCWORKPUPILREACTTOLIGHTODRE,

        GETSETUPOPTICDOCWORKPUPILREACTTONEARODRE,
        CREATESETUPOPTICDOCWORKPUPILREACTTONEARODRE,
        UPDATESETUPOPTICDOCWORKPUPILREACTTONEARODRE,
        DELETESETUPOPTICDOCWORKPUPILREACTTONEARODRE,

        GETSETUPOPTICDOCWORKLENSEABNORMALODRE,
        CREATESETUPOPTICDOCWORKLENSEABNORMALODRE,
        UPDATESETUPOPTICDOCWORKLENSEABNORMALODRE,
        DELETESETUPOPTICDOCWORKLENSEABNORMALODRE,

        GETSETUPOPTICDOCWORKDRAWGONISCOPYODRE,
        CREATESETUPOPTICDOCWORKDRAWGONISCOPYODRE,
        UPDATESETUPOPTICDOCWORKDRAWGONISCOPYODRE,
        DELETESETUPOPTICDOCWORKDRAWGONISCOPYODRE,

        GETSETUPOPTICCOUNSELLWORKCOUNSELLORSURGERYTYPE,
        CREATESETUPOPTICCOUNSELLWORKCOUNSELLORSURGERYTYPE,
        UPDATESETUPOPTICCOUNSELLWORKCOUNSELLORSURGERYTYPE,
        DELETESETUPOPTICCOUNSELLWORKCOUNSELLORSURGERYTYPE,
        GETSETUPOPTICCOUNSELLWORKCOUNSELLORIOLIMPLANTTYPE,
        CREATESETUPOPTICCOUNSELLWORKCOUNSELLORIOLIMPLANTTYPE,
        UPDATESETUPOPTICCOUNSELLWORKCOUNSELLORIOLIMPLANTTYPE,
        DELETESETUPOPTICCOUNSELLWORKCOUNSELLORIOLIMPLANTTYPE,
        GETSETUPOPTICCOUNSELLWORKESTIMATEDISCOUNT,
        CREATESETUPOPTICCOUNSELLWORKESTIMATEDISCOUNT,
        UPDATESETUPOPTICCOUNSELLWORKESTIMATEDISCOUNT,
        DELETESETUPOPTICCOUNSELLWORKESTIMATEDISCOUNT,
        GETSETUPOPTICPROCEDURENEWGLASSLENSETYPEOD,
        CREATESETUPOPTICPROCEDURENEWGLASSLENSETYPEOD,
        UPDATESETUPOPTICPROCEDURENEWGLASSLENSETYPEOD,
        DELETESETUPOPTICPROCEDURENEWGLASSLENSETYPEOD,

        GETSETUPOPTICPROCEDURENEWGLASSLENSEMATERIALOD,
        CREATESETUPOPTICPROCEDURENEWGLASSLENSEMATERIALOD,
        UPDATESETUPOPTICPROCEDURENEWGLASSLENSEMATERIALOD,
        DELETESETUPOPTICPROCEDURENEWGLASSLENSEMATERIALOD,

        GETSETUPOPTICPROCEDURENEWGLASSLENSESTYLEOD,
        CREATESETUPOPTICPROCEDURENEWGLASSLENSESTYLEOD,
        UPDATESETUPOPTICPROCEDURENEWGLASSLENSESTYLEOD,
        DELETESETUPOPTICPROCEDURENEWGLASSLENSESTYLEOD,

        GETSETUPOPTICPROCEDURENEWGLASSLENSETHICKNESSTYPEOD,
        CREATESETUPOPTICPROCEDURENEWGLASSLENSETHICKNESSTYPEOD,
        UPDATESETUPOPTICPROCEDURENEWGLASSLENSETHICKNESSTYPEOD,
        DELETESETUPOPTICPROCEDURENEWGLASSLENSETHICKNESSTYPEOD,

        GETSETUPOPTICPROCEDURENEWGLASSLABCOATINGTYPE,
        CREATESETUPOPTICPROCEDURENEWGLASSLABCOATINGTYPE,
        UPDATESETUPOPTICPROCEDURENEWGLASSLABCOATINGTYPE,
        DELETESETUPOPTICPROCEDURENEWGLASSLABCOATINGTYPE,

        GETSETUPOPTICPROCEDURENEWGLASSFACTORYCOATING,
        CREATESETUPOPTICPROCEDURENEWGLASSFACTORYCOATING,
        UPDATESETUPOPTICPROCEDURENEWGLASSFACTORYCOATING,
        DELETESETUPOPTICPROCEDURENEWGLASSFACTORYCOATING,
        GETSETUPOPTICPROCEDURENEWGLASSFRAMEMATERIAL,
        CREATESETUPOPTICPROCEDURENEWGLASSFRAMEMATERIAL,
        UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEMATERIAL,
        DELETESETUPOPTICPROCEDURENEWGLASSFRAMEMATERIAL,
        GETSETUPOPTICPROCEDURENEWGLASSBEVEL,
        CREATESETUPOPTICPROCEDURENEWGLASSBEVEL,
        UPDATESETUPOPTICPROCEDURENEWGLASSBEVEL,
        DELETESETUPOPTICPROCEDURENEWGLASSBEVEL,
        GETSETUPOPTICPROCEDURENEWGLASSEDGES,
        CREATESETUPOPTICPROCEDURENEWGLASSEDGES,
        UPDATESETUPOPTICPROCEDURENEWGLASSEDGES,
        DELETESETUPOPTICPROCEDURENEWGLASSEDGES,
        GETSETUPOPTICPROCEDURENEWGLASSTINTTYPE,
        CREATESETUPOPTICPROCEDURENEWGLASSTINTTYPE,
        UPDATESETUPOPTICPROCEDURENEWGLASSTINTTYPE,
        DELETESETUPOPTICPROCEDURENEWGLASSTINTTYPE,
        GETSETUPOPTICPROCEDURENEWGLASSFRAMEID,
        CREATESETUPOPTICPROCEDURENEWGLASSFRAMEID,
        UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEID,
        DELETESETUPOPTICPROCEDURENEWGLASSFRAMEID,
        GETSETUPOPTICPROCEDURENEWGLASSEYESIZE,
        CREATESETUPOPTICPROCEDURENEWGLASSEYESIZE,
        UPDATESETUPOPTICPROCEDURENEWGLASSEYESIZE,
        DELETESETUPOPTICPROCEDURENEWGLASSEYESIZE,
        GETSETUPOPTICPROCEDURENEWGLASSEYERATIO,
        CREATESETUPOPTICPROCEDURENEWGLASSEYERATIO,
        UPDATESETUPOPTICPROCEDURENEWGLASSEYERATIO,
        DELETESETUPOPTICPROCEDURENEWGLASSEYERATIO,
        GETSETUPOPTICPROCEDURENEWGLASSFRAMEBC,
        CREATESETUPOPTICPROCEDURENEWGLASSFRAMEBC,
        UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEBC,
        DELETESETUPOPTICPROCEDURENEWGLASSFRAMEBC,
        GETSETUPOPTICPROCEDURENEWGLASSFRAMEMODEL,
        CREATESETUPOPTICPROCEDURENEWGLASSFRAMEMODEL,
        UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEMODEL,
        DELETESETUPOPTICPROCEDURENEWGLASSFRAMEMODEL,
        GETSETUPOPTICPROCEDURENEWGLASSFRAMEDBL,
        CREATESETUPOPTICPROCEDURENEWGLASSFRAMEDBL,
        UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEDBL,
        DELETESETUPOPTICPROCEDURENEWGLASSFRAMEDBL,
        GETSETUPOPTICPROCEDURENEWGLASSSTABILITYCOEFF,
        CREATESETUPOPTICPROCEDURENEWGLASSSTABILITYCOEFF,
        UPDATESETUPOPTICPROCEDURENEWGLASSSTABILITYCOEFF,
        DELETESETUPOPTICPROCEDURENEWGLASSSTABILITYCOEFF,
        GETSETUPOPTICPROCEDURENEWGLASSFRAMESHAPE,
        CREATESETUPOPTICPROCEDURENEWGLASSFRAMESHAPE,
        UPDATESETUPOPTICPROCEDURENEWGLASSFRAMESHAPE,
        DELETESETUPOPTICPROCEDURENEWGLASSFRAMESHAPE,
        GETSETUPOPTICPROCEDURENEWGLASSVENDOR,
        CREATESETUPOPTICPROCEDURENEWGLASSVENDOR,
        UPDATESETUPOPTICPROCEDURENEWGLASSVENDOR,
        DELETESETUPOPTICPROCEDURENEWGLASSVENDOR,
        GETSETUPOPTICPROCEDURENEWGLASSFRAMETMPL,
        CREATESETUPOPTICPROCEDURENEWGLASSFRAMETMPL,
        UPDATESETUPOPTICPROCEDURENEWGLASSFRAMETMPL,
        DELETESETUPOPTICPROCEDURENEWGLASSFRAMETMPL,
        GETSETUPOPTICPROCEDURENEWGLASSECXX,
        CREATESETUPOPTICPROCEDURENEWGLASSECXX,
        UPDATESETUPOPTICPROCEDURENEWGLASSECXX,
        DELETESETUPOPTICPROCEDURENEWGLASSECXX,
        GETSETUPOPTICPROCEDURENEWGLASSFRAMESOURCE,
        CREATESETUPOPTICPROCEDURENEWGLASSFRAMESOURCE,
        UPDATESETUPOPTICPROCEDURENEWGLASSFRAMESOURCE,
        DELETESETUPOPTICPROCEDURENEWGLASSFRAMESOURCE,
        GETSETUPOPTICPROCEDURENEWGLASSMANUFACTURE,
        CREATESETUPOPTICPROCEDURENEWGLASSMANUFACTURE,
        UPDATESETUPOPTICPROCEDURENEWGLASSMANUFACTURE,
        DELETESETUPOPTICPROCEDURENEWGLASSMANUFACTURE,
        GETSETUPOPTICPROCEDURENEWGLASSBDIM,
        CREATESETUPOPTICPROCEDURENEWGLASSBDIM,
        UPDATESETUPOPTICPROCEDURENEWGLASSBDIM,
        DELETESETUPOPTICPROCEDURENEWGLASSBDIM,
        GETSETUPOPTICPROCEDURENEWGLASSECXY,
        CREATESETUPOPTICPROCEDURENEWGLASSECXY,
        UPDATESETUPOPTICPROCEDURENEWGLASSECXY,
        DELETESETUPOPTICPROCEDURENEWGLASSECXY,
        GETSETUPOPTICPROCEDURENEWGLASSFRAMETYPE,
        CREATESETUPOPTICPROCEDURENEWGLASSFRAMETYPE,
        UPDATESETUPOPTICPROCEDURENEWGLASSFRAMETYPE,
        DELETESETUPOPTICPROCEDURENEWGLASSFRAMETYPE,
        GETSETUPOPTICPROCEDURENEWGLASSBRAND,
        CREATESETUPOPTICPROCEDURENEWGLASSBRAND,
        UPDATESETUPOPTICPROCEDURENEWGLASSBRAND,
        DELETESETUPOPTICPROCEDURENEWGLASSBRAND,
        GETSETUPOPTICPROCEDURENEWGLASSCIRCUM,
        CREATESETUPOPTICPROCEDURENEWGLASSCIRCUM,
        UPDATESETUPOPTICPROCEDURENEWGLASSCIRCUM,
        DELETESETUPOPTICPROCEDURENEWGLASSCIRCUM,
        GETSETUPOPTICPROCEDURENEWGLASSECXZ,
        CREATESETUPOPTICPROCEDURENEWGLASSECXZ,
        UPDATESETUPOPTICPROCEDURENEWGLASSECXZ,
        DELETESETUPOPTICPROCEDURENEWGLASSECXZ,
        GETSETUPOPTICPROCEDURENEWGLASSCOLLECTION,
        CREATESETUPOPTICPROCEDURENEWGLASSCOLLECTION,
        UPDATESETUPOPTICPROCEDURENEWGLASSCOLLECTION,
        DELETESETUPOPTICPROCEDURENEWGLASSCOLLECTION,
        GETSETUPOPTICPROCEDURENEWGLASSFRAMEED,
        CREATESETUPOPTICPROCEDURENEWGLASSFRAMEED,
        UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEED,
        DELETESETUPOPTICPROCEDURENEWGLASSFRAMEED,
        GETSETUPOPTICPROCEDURENEWGLASSREAD,
        CREATESETUPOPTICPROCEDURENEWGLASSREAD,
        UPDATESETUPOPTICPROCEDURENEWGLASSREAD,
        DELETESETUPOPTICPROCEDURENEWGLASSREAD,
        GETSETUPOPTICPROCEDURENEWGLASSFRAMECOLOR,
        CREATESETUPOPTICPROCEDURENEWGLASSFRAMECOLOR,
        UPDATESETUPOPTICPROCEDURENEWGLASSFRAMECOLOR,
        DELETESETUPOPTICPROCEDURENEWGLASSFRAMECOLOR,
        GETSETUPOPTICPROCEDURENEWGLASSPANTO,
        CREATESETUPOPTICPROCEDURENEWGLASSPANTO,
        UPDATESETUPOPTICPROCEDURENEWGLASSPANTO,
        DELETESETUPOPTICPROCEDURENEWGLASSPANTO,
        GETSETUPOPTICPROCEDURENEWGLASSHEADCAPE,
        CREATESETUPOPTICPROCEDURENEWGLASSHEADCAPE,
        UPDATESETUPOPTICPROCEDURENEWGLASSHEADCAPE,
        DELETESETUPOPTICPROCEDURENEWGLASSHEADCAPE,
        GETSETUPOPTICPROCEDURENEWGLASSFRAMEDETAILMATERIAL,
        CREATESETUPOPTICPROCEDURENEWGLASSFRAMEDETAILMATERIAL,
        UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEDETAILMATERIAL,
        DELETESETUPOPTICPROCEDURENEWGLASSFRAMEDETAILMATERIAL,
        GETSETUPOPTICPROCEDURENEWGLASSFRAMEFIT,
        CREATESETUPOPTICPROCEDURENEWGLASSFRAMEFIT,
        UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEFIT,
        DELETESETUPOPTICPROCEDURENEWGLASSFRAMEFIT,
        GETSETUPOPTICPROCEDURENEWGLASSCORRIDORR,
        CREATESETUPOPTICPROCEDURENEWGLASSCORRIDORR,
        UPDATESETUPOPTICPROCEDURENEWGLASSCORRIDORR,
        DELETESETUPOPTICPROCEDURENEWGLASSCORRIDORR,
        GETSETUPOPTICPROCEDURENEWGLASSWRAPANGLE,
        CREATESETUPOPTICPROCEDURENEWGLASSWRAPANGLE,
        UPDATESETUPOPTICPROCEDURENEWGLASSWRAPANGLE,
        DELETESETUPOPTICPROCEDURENEWGLASSWRAPANGLE,
        GETSETUPOPTICPROCEDURENEWGLASSCORRIDORL,
        CREATESETUPOPTICPROCEDURENEWGLASSCORRIDORL,
        UPDATESETUPOPTICPROCEDURENEWGLASSCORRIDORL,
        DELETESETUPOPTICPROCEDURENEWGLASSCORRIDORL,
        GETSETUPOPTICPROCEDURENEWGLASSFRAMESTATUS,
        CREATESETUPOPTICPROCEDURENEWGLASSFRAMESTATUS,
        UPDATESETUPOPTICPROCEDURENEWGLASSFRAMESTATUS,
        DELETESETUPOPTICPROCEDURENEWGLASSFRAMESTATUS,
        GETSETUPOPTICPROCEDURESURGERYPROCUDEURETYPE,
        CREATESETUPOPTICPROCEDURESURGERYPROCUDEURETYPE,
        UPDATESETUPOPTICPROCEDURESURGERYPROCUDEURETYPE,
        DELETESETUPOPTICPROCEDURESURGERYPROCUDEURETYPE,
        GETSETUPOPTICPROCEDURESURGERYPROCUDEURENAME,
        CREATESETUPOPTICPROCEDURESURGERYPROCUDEURENAME,
        UPDATESETUPOPTICPROCEDURESURGERYPROCUDEURENAME,
        DELETESETUPOPTICPROCEDURESURGERYPROCUDEURENAME,
        GETSETUPOPTICPROCEDURELASIKSURGERYPOWERUSED,
        CREATESETUPOPTICPROCEDURELASIKSURGERYPOWERUSED,
        UPDATESETUPOPTICPROCEDURELASIKSURGERYPOWERUSED,
        DELETESETUPOPTICPROCEDURELASIKSURGERYPOWERUSED,
        GETOPHTHALMOLOGYOPDPASTOCCULARHIST,
        CREATEOPHTHALMOLOGYOPDPASTOCCULARHIST,
        UPDATEOPHTHALMOLOGYOPDPASTOCCULARHIST,
        DELETEOPHTHALMOLOGYOPDPASTOCCULARHIST,
        GETOPHTHALMOLOGYOPDSYSTEMICILLNESS,
        CREATEOPHTHALMOLOGYOPDSYSTEMICILLNESS,
        UPDATEOPHTHALMOLOGYOPDSYSTEMICILLNESS,
        DELETEOPHTHALMOLOGYOPDSYSTEMICILLNESS,
        GETOPHTHALMOLOGYOPDFAMILYHIST,
        CREATEOPHTHALMOLOGYOPDFAMILYHIST,
        UPDATEOPHTHALMOLOGYOPDFAMILYHIST,
        DELETEOPHTHALMOLOGYOPDFAMILYHIST,
        GETOPHTHALMOLOGYOPDALLERGYHIST,
        CREATEOPHTHALMOLOGYOPDALLERGYHIST,
        UPDATEOPHTHALMOLOGYOPDALLERGYHIST,
        DELETEOPHTHALMOLOGYOPDALLERGYHIST,

        GETOPHTHALMOLOGYOPDGLASSTYPE,
        CREATEOPHTHALMOLOGYOPDGLASSTYPE,
        UPDATEOPHTHALMOLOGYOPDGLASSTYPE,
        DELETEOPHTHALMOLOGYOPDGLASSTYPE,
        GETOPHTHALMOLOGYOPDLENSETYPE,
        CREATEOPHTHALMOLOGYOPDLENSETYPE,
        UPDATEOPHTHALMOLOGYOPDLENSETYPE,
        DELETEOPHTHALMOLOGYOPDLENSETYPE,
        GETOPHTHALMOLOGYOPDCOVERDISTEYE,
        CREATEOPHTHALMOLOGYOPDCOVERDISTEYE,
        UPDATEOPHTHALMOLOGYOPDCOVERDISTEYE,
        DELETEOPHTHALMOLOGYOPDCOVERDISTEYE,
        GETOPHTHALMOLOGYOPDCOVERDISTOPTION,
        CREATEOPHTHALMOLOGYOPDCOVERDISTOPTION,
        UPDATEOPHTHALMOLOGYOPDCOVERDISTOPTION,
        DELETEOPHTHALMOLOGYOPDCOVERDISTOPTION,
        GETOPHTHALMOLOGYOPDCOVERNNEAREYE,
        CREATEOPHTHALMOLOGYOPDCOVERNNEAREYE,
        UPDATEOPHTHALMOLOGYOPDCOVERNNEAREYE,
        DELETEOPHTHALMOLOGYOPDCOVERNNEAREYE,
        GETOPHTHALMOLOGYOPDCOVERNEAROPTION,
        CREATEOPHTHALMOLOGYOPDCOVERNEAROPTION,
        UPDATEOPHTHALMOLOGYOPDCOVERNEAROPTION,
        DELETEOPHTHALMOLOGYOPDCOVERNEAROPTION,
        GETOPHTHALMOLOGYOPDOCULARMOVEMENTODRIGHEYE,
        CREATEOPHTHALMOLOGYOPDOCULARMOVEMENTODRIGHEYE,
        UPDATEOPHTHALMOLOGYOPDOCULARMOVEMENTODRIGHEYE,
        DELETEOPHTHALMOLOGYOPDOCULARMOVEMENTODRIGHEYE,

        GETOPHTHALMOLOGYOPDFUNDUSDISCODRE,
        CREATEOPHTHALMOLOGYOPDFUNDUSDISCODRE,
        UPDATEOPHTHALMOLOGYOPDFUNDUSDISCODRE,
        DELETEOPHTHALMOLOGYOPDFUNDUSDISCODRE,
        GETOPHTHALMOLOGYOPDFUNDUSMACULAODRE,
        CREATEOPHTHALMOLOGYOPDFUNDUSMACULAODRE,
        UPDATEOPHTHALMOLOGYOPDFUNDUSMACULAODRE,
        DELETEOPHTHALMOLOGYOPDFUNDUSMACULAODRE,
        GETOPHTHALMOLOGYOPDFUNDUSPERIPHERALODRE,
        CREATEOPHTHALMOLOGYOPDFUNDUSPERIPHERALODRE,
        UPDATEOPHTHALMOLOGYOPDFUNDUSPERIPHERALODRE,
        DELETEOPHTHALMOLOGYOPDFUNDUSPERIPHERALODRE,
        GETOPHTHALMOLOGYOPDFUNDUSCDODRE,
        CREATEOPHTHALMOLOGYOPDFUNDUSCDODRE,
        UPDATEOPHTHALMOLOGYOPDFUNDUSCDODRE,
        DELETEOPHTHALMOLOGYOPDFUNDUSCDODRE,
        GETOPHTHALMOLOGYOPDGLAUCOMAIOPODRE,
        CREATEOPHTHALMOLOGYOPDGLAUCOMAIOPODRE,
        UPDATEOPHTHALMOLOGYOPDGLAUCOMAIOPODRE,
        DELETEOPHTHALMOLOGYOPDGLAUCOMAIOPODRE,
        GETOPHTHALMOLOGYOPDGLAUCOMADISCRATIOODRE,
        CREATEOPHTHALMOLOGYOPDGLAUCOMADISCRATIOODRE,
        UPDATEOPHTHALMOLOGYOPDGLAUCOMADISCRATIOODRE,
        DELETEOPHTHALMOLOGYOPDGLAUCOMADISCRATIOODRE,
        GETSETUPOPTICVISIONEYECHARTDISTANCE,
        CREATESETUPOPTICVISIONEYECHARTDISTANCE,
        UPDATESETUPOPTICVISIONEYECHARTDISTANCE,
        DELETESETUPOPTICVISIONEYECHARTDISTANCE,
        GETSETUPOPTICVISIONEYECHARTNEAR,
        CREATESETUPOPTICVISIONEYECHARTNEAR,
        UPDATESETUPOPTICVISIONEYECHARTNEAR,
        DELETESETUPOPTICVISIONEYECHARTNEAR,
        GETSETUPOPTICVISIONEYECHARTSPHERICAL,
        CREATESETUPOPTICVISIONEYECHARTSPHERICAL,
        UPDATESETUPOPTICVISIONEYECHARTSPHERICAL,
        DELETESETUPOPTICVISIONEYECHARTSPHERICAL,
        GETSETUPOPTICVISIONEYECHARTCYLINDERICAL,
        CREATESETUPOPTICVISIONEYECHARTCYLINDERICAL,
        UPDATESETUPOPTICVISIONEYECHARTCYLINDERICAL,
        DELETESETUPOPTICVISIONEYECHARTCYLINDERICAL,
        GETSETUPOPTICVISIONEYECHARTAXIS,
        CREATESETUPOPTICVISIONEYECHARTAXIS,
        UPDATESETUPOPTICVISIONEYECHARTAXIS,
        DELETESETUPOPTICVISIONEYECHARTAXIS,
        GETSETUPOPTICVISIONEYECHARTDIAMETER,
        CREATESETUPOPTICVISIONEYECHARTDIAMETER,
        UPDATESETUPOPTICVISIONEYECHARTDIAMETER,
        DELETESETUPOPTICVISIONEYECHARTDIAMETER,

} from '../actions/types';

const initialState = {
}


export default function (state = initialState, action) {
        switch (action.type) {

                case CREATEOPHTHALMOLOGYOPDPASTOCCULARHIST:
                        return {
                                ...state,
                                ophthalmologyopdpastoccularhistSaveStatus: action.payload.success,
                        }
                case GETOPHTHALMOLOGYOPDPASTOCCULARHIST:
                        return {
                                ...state,
                                ophthalmologyopdpastoccularhistList: action.payload.data,
                        }
                case UPDATEOPHTHALMOLOGYOPDPASTOCCULARHIST:

                        return {
                                ...state,
                                ophthalmologyopdpastoccularhistUpdateStatus: action.payload.success,
                        }

                case DELETEOPHTHALMOLOGYOPDPASTOCCULARHIST:
                        return {
                                ...state,
                                ophthalmologyopdpastoccularhistDeleteStatus: action.payload.success,
                        }
                case CREATEOPHTHALMOLOGYOPDSYSTEMICILLNESS:
                        console.log("Reducer Received Data:", action.payload);
                        return {
                                ...state,
                                ophthalmologyopdsystemicillnessSaveStatus: action.payload.success,
                        }
                case GETOPHTHALMOLOGYOPDSYSTEMICILLNESS:
                        return {
                                ...state,
                                ophthalmologyopdsystemicillnesstList: action.payload.data,
                        }
                case UPDATEOPHTHALMOLOGYOPDSYSTEMICILLNESS:
                        return {
                                ...state,
                                ophthalmologyopdsystemicillnessUpdateStatus: action.payload.success,
                        }

                case DELETEOPHTHALMOLOGYOPDSYSTEMICILLNESS:
                        return {
                                ...state,
                                ophthalmologyopdsystemicillnessDeleteStatus: action.payload.success,
                        }
                case CREATEOPHTHALMOLOGYOPDFAMILYHIST:
                        return {
                                ...state,
                                ophthalmologyopdfamilyhistSaveStatus: action.payload.success,
                        }
                case GETOPHTHALMOLOGYOPDFAMILYHIST:
                        return {
                                ...state,
                                ophthalmologyopdfamilyhistList: action.payload.data,
                        }
                case UPDATEOPHTHALMOLOGYOPDFAMILYHIST:
                        return {
                                ...state,
                                ophthalmologyopdfamilyhistUpdateStatus: action.payload.success,
                        }
                case DELETEOPHTHALMOLOGYOPDFAMILYHIST:
                        return {
                                ...state,
                                ophthalmologyopdfamilyhistDeleteStatus: action.payload.success,
                        }
                case CREATEOPHTHALMOLOGYOPDALLERGYHIST:
                        return {
                                ...state,
                                ophthalmologyopdallergyhistSaveStatus: action.payload.success,
                        }
                case GETOPHTHALMOLOGYOPDALLERGYHIST:
                        return {
                                ...state,
                                ophthalmologyopdallergyhistList: action.payload.data,
                        }
                case UPDATEOPHTHALMOLOGYOPDALLERGYHIST:
                        return {
                                ...state,
                                ophthalmologyopdallergyhistUpdateStatus: action.payload.success,
                        }

                case DELETEOPHTHALMOLOGYOPDALLERGYHIST:
                        return {
                                ...state,
                                ophthalmologyopdallergyhistDeleteStatus: action.payload.success,
                        }

                case GETOPHTHALMOLOGYOPDGLASSTYPE:
                        return { ...state, ophthalmologyopdGlassTypeList: action.payload.data, }
                case CREATEOPHTHALMOLOGYOPDGLASSTYPE:
                        return { ...state, ophthalmologyopdGlassTypeSaveStatus: action.payload.success, }
                case UPDATEOPHTHALMOLOGYOPDGLASSTYPE:
                        return { ...state, ophthalmologyopdGlassTypeUpdateStatus: action.payload.success, }
                case DELETEOPHTHALMOLOGYOPDGLASSTYPE:
                        return { ...state, ophthalmologyopdGlassTypeDeleteStatus: action.payload.success, }
                case GETOPHTHALMOLOGYOPDLENSETYPE:
                        return { ...state, ophthalmologyopdLenseTypeList: action.payload.data, }
                case CREATEOPHTHALMOLOGYOPDLENSETYPE:
                        return { ...state, ophthalmologyopdLenseTypeSaveStatus: action.payload.success, }
                case UPDATEOPHTHALMOLOGYOPDLENSETYPE:
                        return { ...state, ophthalmologyopdLenseTypeUpdateStatus: action.payload.success, }
                case DELETEOPHTHALMOLOGYOPDLENSETYPE:
                        return { ...state, ophthalmologyopdLenseTypeDeleteStatus: action.payload.success, }
                case GETOPHTHALMOLOGYOPDCOVERDISTEYE:
                        return { ...state, ophthalmologyopdCoverDistEyeList: action.payload.data, }
                case CREATEOPHTHALMOLOGYOPDCOVERDISTEYE:
                        return { ...state, ophthalmologyopdCoverDistEyeSaveStatus: action.payload.success, }
                case UPDATEOPHTHALMOLOGYOPDCOVERDISTEYE:
                        return { ...state, ophthalmologyopdCoverDistEyeUpdateStatus: action.payload.success, }
                case DELETEOPHTHALMOLOGYOPDCOVERDISTEYE:
                        return { ...state, ophthalmologyopdCoverDistEyeDeleteStatus: action.payload.success, }
                case GETOPHTHALMOLOGYOPDCOVERDISTOPTION:
                        return { ...state, ophthalmologyopdCoverDistOptionList: action.payload.data, }
                case CREATEOPHTHALMOLOGYOPDCOVERDISTOPTION:
                        return { ...state, ophthalmologyopdCoverDistOptionSaveStatus: action.payload.success, }
                case UPDATEOPHTHALMOLOGYOPDCOVERDISTOPTION:
                        return { ...state, ophthalmologyopdCoverDistOptionUpdateStatus: action.payload.success, }
                case DELETEOPHTHALMOLOGYOPDCOVERDISTOPTION:
                        return { ...state, ophthalmologyopdCoverDistOptionDeleteStatus: action.payload.success, }
                case GETOPHTHALMOLOGYOPDCOVERNNEAREYE:
                        return { ...state, ophthalmologyopdCoverNearEyeList: action.payload.data, }
                case CREATEOPHTHALMOLOGYOPDCOVERNNEAREYE:
                        return { ...state, ophthalmologyopdCoverNearEyeSaveStatus: action.payload.success, }
                case UPDATEOPHTHALMOLOGYOPDCOVERNNEAREYE:
                        return { ...state, ophthalmologyopdCoverNearEyeUpdateStatus: action.payload.success, }
                case DELETEOPHTHALMOLOGYOPDCOVERNNEAREYE:
                        return { ...state, ophthalmologyopdCoverNearEyeDeleteStatus: action.payload.success, }
                case GETOPHTHALMOLOGYOPDCOVERNEAROPTION:
                        return { ...state, ophthalmologyopdCoverNearOptionList: action.payload.data, }
                case CREATEOPHTHALMOLOGYOPDCOVERNEAROPTION:
                        return { ...state, ophthalmologyopdCoverNearOptionSaveStatus: action.payload.success, }
                case UPDATEOPHTHALMOLOGYOPDCOVERNEAROPTION:
                        return { ...state, ophthalmologyopdCoverNearOptionUpdateStatus: action.payload.success, }
                case DELETEOPHTHALMOLOGYOPDCOVERNEAROPTION:
                        return { ...state, ophthalmologyopdCoverNearOptionDeleteStatus: action.payload.success, }
                case GETOPHTHALMOLOGYOPDOCULARMOVEMENTODRIGHEYE:
                        return { ...state, ophthalmologyopdOccularMovementODREList: action.payload.data, }
                case CREATEOPHTHALMOLOGYOPDOCULARMOVEMENTODRIGHEYE:
                        return { ...state, ophthalmologyopdOccularMovementODRESaveStatus: action.payload.success, }
                case UPDATEOPHTHALMOLOGYOPDOCULARMOVEMENTODRIGHEYE:
                        return { ...state, ophthalmologyopdOccularMovementODREUpdateStatus: action.payload.success, }
                case DELETEOPHTHALMOLOGYOPDOCULARMOVEMENTODRIGHEYE:
                        return { ...state, ophthalmologyopdOccularMovementODREDeleteStatus: action.payload.success, }
                case GETOPHTHALMOLOGYOPDFUNDUSDISCODRE:
                        return { ...state, ophthalmologyopdFundusDiscODREList: action.payload.data, }
                case CREATEOPHTHALMOLOGYOPDFUNDUSDISCODRE:
                        return { ...state, ophthalmologyopdFundusDiscODRESaveStatus: action.payload.success, }
                case UPDATEOPHTHALMOLOGYOPDFUNDUSDISCODRE:
                        return { ...state, ophthalmologyopdFundusDiscODREUpdateStatus: action.payload.success, }
                case DELETEOPHTHALMOLOGYOPDFUNDUSDISCODRE:
                        return { ...state, ophthalmologyopdFundusDiscODREDeleteStatus: action.payload.success, }
                case GETOPHTHALMOLOGYOPDFUNDUSMACULAODRE:
                        return { ...state, ophthalmologyopdMaculaODREList: action.payload.data, }
                case CREATEOPHTHALMOLOGYOPDFUNDUSMACULAODRE:
                        return { ...state, ophthalmologyopdMaculaODRESaveStatus: action.payload.success, }
                case UPDATEOPHTHALMOLOGYOPDFUNDUSMACULAODRE:
                        return { ...state, ophthalmologyopdMaculaODREUpdateStatus: action.payload.success, }
                case DELETEOPHTHALMOLOGYOPDFUNDUSMACULAODRE:
                        return { ...state, ophthalmologyopdMaculaODREDeleteStatus: action.payload.success, }
                case GETOPHTHALMOLOGYOPDFUNDUSPERIPHERALODRE:
                        return { ...state, ophthalmologyopdPeripheralODREList: action.payload.data, }
                case CREATEOPHTHALMOLOGYOPDFUNDUSPERIPHERALODRE:
                        return { ...state, ophthalmologyopdPeripheralODRESaveStatus: action.payload.success, }
                case UPDATEOPHTHALMOLOGYOPDFUNDUSPERIPHERALODRE:
                        return { ...state, ophthalmologyopdPeripheralODREUpdateStatus: action.payload.success, }
                case DELETEOPHTHALMOLOGYOPDFUNDUSPERIPHERALODRE:
                        return { ...state, ophthalmologyopdPeripheralODREDeleteStatus: action.payload.success, }
                case GETOPHTHALMOLOGYOPDFUNDUSCDODRE:
                        return { ...state, ophthalmologyopdCDODREList: action.payload.data, }
                case CREATEOPHTHALMOLOGYOPDFUNDUSCDODRE:
                        return { ...state, ophthalmologyopdCDODRESaveStatus: action.payload.success, }
                case UPDATEOPHTHALMOLOGYOPDFUNDUSCDODRE:
                        return { ...state, ophthalmologyopdCDODREUpdateStatus: action.payload.success, }
                case DELETEOPHTHALMOLOGYOPDFUNDUSCDODRE:
                        return { ...state, ophthalmologyopdCDODREDeleteStatus: action.payload.success, }
                case GETOPHTHALMOLOGYOPDGLAUCOMAIOPODRE:
                        return { ...state, ophthalmologyopdIOPODREList: action.payload.data, }
                case CREATEOPHTHALMOLOGYOPDGLAUCOMAIOPODRE:
                        return { ...state, ophthalmologyopdIOPODRESaveStatus: action.payload.success, }
                case UPDATEOPHTHALMOLOGYOPDGLAUCOMAIOPODRE:
                        return { ...state, ophthalmologyopdIOPODREUpdateStatus: action.payload.success, }
                case DELETEOPHTHALMOLOGYOPDGLAUCOMAIOPODRE:
                        return { ...state, ophthalmologyopdIOPODREDeleteStatus: action.payload.success, }
                case GETOPHTHALMOLOGYOPDGLAUCOMADISCRATIOODRE:
                        return { ...state, ophthalmologyopdDiscRatioODREList: action.payload.data, }
                case CREATEOPHTHALMOLOGYOPDGLAUCOMADISCRATIOODRE:
                        return { ...state, ophthalmologyopdDiscRatioODRESaveStatus: action.payload.success, }
                case UPDATEOPHTHALMOLOGYOPDGLAUCOMADISCRATIOODRE:
                        return { ...state, ophthalmologyopdDiscRatioODREUpdateStatus: action.payload.success, }
                case DELETEOPHTHALMOLOGYOPDGLAUCOMADISCRATIOODRE:
                        return { ...state, ophthalmologyopdDiscRatioODREDeleteStatus: action.payload.success, }


                case GETSETUPOPTICDOCWORKPUPILSIZEODRE:
                        return { ...state, SetupOpticDocWorkPupilSizeODREList: action.payload.data, }
                case CREATESETUPOPTICDOCWORKPUPILSIZEODRE:
                        return { ...state, SetupOpticDocWorkPupilSizeODRESaveStatus: action.payload.success, }
                case UPDATESETUPOPTICDOCWORKPUPILSIZEODRE:
                        return { ...state, SetupOpticDocWorkPupilSizeODREUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICDOCWORKPUPILSIZEODRE:
                        return { ...state, SetupOpticDocWorkPupilSizeODREDeleteStatus: action.payload.success, }

                case GETSETUPOPTICDOCWORKPUPILSHAPEODRE:
                        return { ...state, SetupOpticDocWorkPupilShapeODREList: action.payload.data, }
                case CREATESETUPOPTICDOCWORKPUPILSHAPEODRE:
                        return { ...state, SetupOpticDocWorkPupilShapeODRESaveStatus: action.payload.success, }
                case UPDATESETUPOPTICDOCWORKPUPILSHAPEODRE:
                        return { ...state, SetupOpticDocWorkPupilShapeODREUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICDOCWORKPUPILSHAPEODRE:
                        return { ...state, SetupOpticDocWorkPupilShapeODREDeleteStatus: action.payload.success, }
                case GETSETUPOPTICDOCWORKPUPILREACTTOLIGHTODRE:
                        return { ...state, SetupOpticDocWorkPupilReactToLightODREList: action.payload.data, }
                case CREATESETUPOPTICDOCWORKPUPILREACTTOLIGHTODRE:
                        return { ...state, SetupOpticDocWorkPupilReactToLightODRESaveStatus: action.payload.success, }
                case UPDATESETUPOPTICDOCWORKPUPILREACTTOLIGHTODRE:
                        return { ...state, SetupOpticDocWorkPupilReactToLightODREUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICDOCWORKPUPILREACTTOLIGHTODRE:
                        return { ...state, SetupOpticDocWorkPupilReactToLightODREDeleteStatus: action.payload.success, }

                case GETSETUPOPTICDOCWORKPUPILREACTTONEARODRE:
                        return { ...state, SetupOpticDocWorkPupilReactToNearODREList: action.payload.data, }
                case CREATESETUPOPTICDOCWORKPUPILREACTTONEARODRE:
                        return { ...state, SetupOpticDocWorkPupilReactToNearODRESaveStatus: action.payload.success, }
                case UPDATESETUPOPTICDOCWORKPUPILREACTTONEARODRE:
                        return { ...state, SetupOpticDocWorkPupilReactToNearODREUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICDOCWORKPUPILREACTTONEARODRE:
                        return { ...state, SetupOpticDocWorkPupilReactToNearODREDeleteStatus: action.payload.success, }
                case GETSETUPOPTICDOCWORKLENSEABNORMALODRE:
                        return { ...state, SetupOpticDocWorkLenseAbnormalityODREList: action.payload.data, }
                case CREATESETUPOPTICDOCWORKLENSEABNORMALODRE:
                        return { ...state, SetupOpticDocWorkLenseAbnormalityODRESaveStatus: action.payload.success, }
                case UPDATESETUPOPTICDOCWORKLENSEABNORMALODRE:
                        return { ...state, SetupOpticDocWorkLenseAbnormalityODREUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICDOCWORKLENSEABNORMALODRE:
                        return { ...state, SetupOpticDocWorkLenseAbnormalityODREDeleteStatus: action.payload.success, }
                case GETSETUPOPTICDOCWORKDRAWGONISCOPYODRE:
                        return { ...state, SetupOpticDocWorkGonioscopyODREList: action.payload.data, }
                case CREATESETUPOPTICDOCWORKDRAWGONISCOPYODRE:
                        return { ...state, SetupOpticDocWorkGonioscopyODRESaveStatus: action.payload.success, }
                case UPDATESETUPOPTICDOCWORKDRAWGONISCOPYODRE:
                        return { ...state, SetupOpticDocWorkGonioscopyODREUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICDOCWORKDRAWGONISCOPYODRE:
                        return { ...state, SetupOpticDocWorkGonioscopyODREDeleteStatus: action.payload.success, }


                case GETSETUPOPTICCOUNSELLWORKCOUNSELLORSURGERYTYPE:
                        return { ...state, SetupOpticCounsellWorkCounsellTypeofSurgeryList: action.payload.data, }
                case CREATESETUPOPTICCOUNSELLWORKCOUNSELLORSURGERYTYPE:
                        return { ...state, SetupOpticCounsellWorkCounsellTypeofSurgerySaveStatus: action.payload.success, }
                case UPDATESETUPOPTICCOUNSELLWORKCOUNSELLORSURGERYTYPE:
                        return { ...state, SetupOpticCounsellWorkCounsellTypeofSurgeryUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICCOUNSELLWORKCOUNSELLORSURGERYTYPE:
                        return { ...state, SetupOpticCounsellWorkCounsellTypeofSurgeryDeleteStatus: action.payload.success, }
                case GETSETUPOPTICCOUNSELLWORKCOUNSELLORIOLIMPLANTTYPE:
                        return { ...state, SetupOpticCounsellWorkCounsellIolImplantList: action.payload.data, }
                case CREATESETUPOPTICCOUNSELLWORKCOUNSELLORIOLIMPLANTTYPE:
                        return { ...state, SetupOpticCounsellWorkCounsellIolImplantSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICCOUNSELLWORKCOUNSELLORIOLIMPLANTTYPE:
                        return { ...state, SetupOpticCounsellWorkCounsellIolImplantUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICCOUNSELLWORKCOUNSELLORIOLIMPLANTTYPE:
                        return { ...state, SetupOpticCounsellWorkCounsellIolImplantDeleteStatus: action.payload.success, }
                case GETSETUPOPTICCOUNSELLWORKESTIMATEDISCOUNT:
                        return { ...state, SetupOpticCounsellWorkEstimateDiscountList: action.payload.data, }
                case CREATESETUPOPTICCOUNSELLWORKESTIMATEDISCOUNT:
                        return { ...state, SetupOpticCounsellWorkEstimateDiscountSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICCOUNSELLWORKESTIMATEDISCOUNT:
                        return { ...state, SetupOpticCounsellWorkEstimateDiscountUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICCOUNSELLWORKESTIMATEDISCOUNT:
                        return { ...state, SetupOpticCounsellWorkEstimateDiscountDeleteStatus: action.payload.success, }
                case GETSETUPOPTICPROCEDURENEWGLASSLENSETYPEOD:
                        return { ...state, SetupOpticProcedureNewGlassLenseTypeOdList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSLENSETYPEOD:
                        return { ...state, SetupOpticProcedureNewGlassLenseTypeOdSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSLENSETYPEOD:
                        return { ...state, SetupOpticProcedureNewGlassLenseTypeOdUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSLENSETYPEOD:
                        return { ...state, SetupOpticProcedureNewGlassLenseTypeOdDeleteStatus: action.payload.success, }
                case GETSETUPOPTICPROCEDURENEWGLASSLENSEMATERIALOD:
                        return { ...state, SetupOpticProcedureNewGlassLenseMaterialODList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSLENSEMATERIALOD:
                        return { ...state, SetupOpticProcedureNewGlassLenseMaterialODSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSLENSEMATERIALOD:
                        return { ...state, SetupOpticProcedureNewGlassLenseMaterialODUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSLENSEMATERIALOD:
                        return { ...state, SetupOpticProcedureNewGlassLenseMaterialODDeleteStatus: action.payload.success, }
                case GETSETUPOPTICPROCEDURENEWGLASSLENSESTYLEOD:
                        return { ...state, SetupOpticProcedureNewGlassLenseStyleODList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSLENSESTYLEOD:
                        return { ...state, SetupOpticProcedureNewGlassLenseStyleODSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSLENSESTYLEOD:
                        return { ...state, SetupOpticProcedureNewGlassLenseStyleODUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSLENSESTYLEOD:
                        return { ...state, SetupOpticProcedureNewGlassLenseStyleODDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSLENSETHICKNESSTYPEOD:
                        return { ...state, SetupOpticProcedureNewGlassLenseThicknessTypeODList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSLENSETHICKNESSTYPEOD:
                        return { ...state, SetupOpticProcedureNewGlassLenseThicknessTypeODSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSLENSETHICKNESSTYPEOD:
                        return { ...state, SetupOpticProcedureNewGlassLenseThicknessTypeODUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSLENSETHICKNESSTYPEOD:
                        return { ...state, SetupOpticProcedureNewGlassLenseThicknessTypeODDeleteStatus: action.payload.success, }
                case GETSETUPOPTICPROCEDURENEWGLASSLABCOATINGTYPE:
                        return { ...state, SetupOpticProcedureNewGlassLabCoatingTypeList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSLABCOATINGTYPE:
                        return { ...state, SetupOpticProcedureNewGlassLabCoatingTypeSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSLABCOATINGTYPE:
                        return { ...state, SetupOpticProcedureNewGlassLabCoatingTypeUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSLABCOATINGTYPE:
                        return { ...state, SetupOpticProcedureNewGlassLabCoatingTypeDeleteStatus: action.payload.success, }


                case GETSETUPOPTICPROCEDURENEWGLASSFACTORYCOATING:
                        return { ...state, SetupOpticProcedureNewGlassFactoryCoatingList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSFACTORYCOATING:
                        return { ...state, SetupOpticProcedureNewGlassFactoryCoatingSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSFACTORYCOATING:
                        return { ...state, SetupOpticProcedureNewGlassFactoryCoatingUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSFACTORYCOATING:
                        return { ...state, SetupOpticProcedureNewGlassFactoryCoatingDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSFRAMEMATERIAL:
                        return { ...state, SetupOpticProcedureNewGlassFrameMaterialList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSFRAMEMATERIAL:
                        return { ...state, SetupOpticProcedureNewGlassFrameMaterialSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEMATERIAL:
                        return { ...state, SetupOpticProcedureNewGlassFrameMaterialUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSFRAMEMATERIAL:
                        return { ...state, SetupOpticProcedureNewGlassFrameMaterialDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSBEVEL:
                        return { ...state, SetupOpticProcedureNewGlassBevelList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSBEVEL:
                        return { ...state, SetupOpticProcedureNewGlassBevelSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSBEVEL:
                        return { ...state, SetupOpticProcedureNewGlassBevelUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSBEVEL:
                        return { ...state, SetupOpticProcedureNewGlassBevelDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSEDGES:
                        return { ...state, SetupOpticProcedureNewGlassEdgesList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSEDGES:
                        return { ...state, SetupOpticProcedureNewGlassEdgesSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSEDGES:
                        return { ...state, SetupOpticProcedureNewGlassEdgesUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSEDGES:
                        return { ...state, SetupOpticProcedureNewGlassEdgesDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSTINTTYPE:
                        return { ...state, SetupOpticProcedureNewGlassTintTypeList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSTINTTYPE:
                        return { ...state, SetupOpticProcedureNewGlassTintTypeSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSTINTTYPE:
                        return { ...state, SetupOpticProcedureNewGlassTintTypeUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSTINTTYPE:
                        return { ...state, SetupOpticProcedureNewGlassTintTypeDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSFRAMEID:
                        return { ...state, SetupOpticProcedureNewGlassFrameIDList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSFRAMEID:
                        return { ...state, SetupOpticProcedureNewGlassFrameIDSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEID:
                        return { ...state, SetupOpticProcedureNewGlassFrameIDUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSFRAMEID:
                        return { ...state, SetupOpticProcedureNewGlassFrameIDDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSEYESIZE:
                        return { ...state, SetupOpticProcedureNewGlassEyeSizeList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSEYESIZE:
                        return { ...state, SetupOpticProcedureNewGlassEyeSizeSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSEYESIZE:
                        return { ...state, SetupOpticProcedureNewGlassEyeSizeUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSEYESIZE:
                        return { ...state, SetupOpticProcedureNewGlassEyeSizeDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSEYERATIO:
                        return { ...state, SetupOpticProcedureNewGlassEyeRatioList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSEYERATIO:
                        return { ...state, SetupOpticProcedureNewGlassEyeRatioSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSEYERATIO:
                        return { ...state, SetupOpticProcedureNewGlassEyeRatioUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSEYERATIO:
                        return { ...state, SetupOpticProcedureNewGlassEyeRatioDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSFRAMEBC:
                        return { ...state, SetupOpticProcedureNewGlassFrameBCList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSFRAMEBC:
                        return { ...state, SetupOpticProcedureNewGlassFrameBCSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEBC:
                        return { ...state, SetupOpticProcedureNewGlassFrameBCUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSFRAMEBC:
                        return { ...state, SetupOpticProcedureNewGlassFrameBCDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSFRAMEMODEL:
                        return { ...state, SetupOpticProcedureNewGlassFrameModelList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSFRAMEMODEL:
                        return { ...state, SetupOpticProcedureNewGlassFrameModelSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEMODEL:
                        return { ...state, SetupOpticProcedureNewGlassFrameModelUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSFRAMEMODEL:
                        return { ...state, SetupOpticProcedureNewGlassFrameModelDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSFRAMEDBL:
                        return { ...state, SetupOpticProcedureNewGlassFrameDBLList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSFRAMEDBL:
                        return { ...state, SetupOpticProcedureNewGlassFrameDBLSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEDBL:
                        return { ...state, SetupOpticProcedureNewGlassFrameDBLUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSFRAMEDBL:
                        return { ...state, SetupOpticProcedureNewGlassFrameDBLDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSSTABILITYCOEFF:
                        return { ...state, SetupOpticProcedureNewGlassStabilityCoeffList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSSTABILITYCOEFF:
                        return { ...state, SetupOpticProcedureNewGlassStabilityCoeffSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSSTABILITYCOEFF:
                        return { ...state, SetupOpticProcedureNewGlassStabilityCoeffUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSSTABILITYCOEFF:
                        return { ...state, SetupOpticProcedureNewGlassStabilityCoeffDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSFRAMESHAPE:
                        return { ...state, SetupOpticProcedureNewGlassFrameShapeList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSFRAMESHAPE:
                        return { ...state, SetupOpticProcedureNewGlassFrameShapeSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSFRAMESHAPE:
                        return { ...state, SetupOpticProcedureNewGlassFrameShapeUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSFRAMESHAPE:
                        return { ...state, SetupOpticProcedureNewGlassFrameShapeDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSVENDOR:
                        return { ...state, SetupOpticProcedureNewGlassVendorList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSVENDOR:
                        return { ...state, SetupOpticProcedureNewGlassVendorSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSVENDOR:
                        return { ...state, SetupOpticProcedureNewGlassVendorUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSVENDOR:
                        return { ...state, SetupOpticProcedureNewGlassVendorDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSFRAMETMPL:
                        return { ...state, SetupOpticProcedureNewGlassFrameTmplList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSFRAMETMPL:
                        return { ...state, SetupOpticProcedureNewGlassFrameTmplSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSFRAMETMPL:
                        return { ...state, SetupOpticProcedureNewGlassFrameTmplUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSFRAMETMPL:
                        return { ...state, SetupOpticProcedureNewGlassFrameTmplDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSECXX:
                        return { ...state, SetupOpticProcedureNewGlassECXXList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSECXX:
                        return { ...state, SetupOpticProcedureNewGlassECXXSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSECXX:
                        return { ...state, SetupOpticProcedureNewGlassECXXUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSECXX:
                        return { ...state, SetupOpticProcedureNewGlassECXXDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSFRAMESOURCE:
                        return { ...state, SetupOpticProcedureNewGlassFrameSourceList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSFRAMESOURCE:
                        return { ...state, SetupOpticProcedureNewGlassFrameSourceSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSFRAMESOURCE:
                        return { ...state, SetupOpticProcedureNewGlassFrameSourceUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSFRAMESOURCE:
                        return { ...state, SetupOpticProcedureNewGlassFrameSourceDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSMANUFACTURE:
                        return { ...state, SetupOpticProcedureNewGlassManufactureeList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSMANUFACTURE:
                        return { ...state, SetupOpticProcedureNewGlassManufactureeSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSMANUFACTURE:
                        return { ...state, SetupOpticProcedureNewGlassManufactureeUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSMANUFACTURE:
                        return { ...state, SetupOpticProcedureNewGlassManufactureeDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSBDIM:
                        return { ...state, SetupOpticProcedureNewGlassBDimList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSBDIM:
                        return { ...state, SetupOpticProcedureNewGlassBDimSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSBDIM:
                        return { ...state, SetupOpticProcedureNewGlassBDimUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSBDIM:
                        return { ...state, SetupOpticProcedureNewGlassBDimDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSECXY:
                        return { ...state, SetupOpticProcedureNewGlassECXYList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSECXY:
                        return { ...state, SetupOpticProcedureNewGlassECXYSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSECXY:
                        return { ...state, SetupOpticProcedureNewGlassECXYUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSECXY:
                        return { ...state, SetupOpticProcedureNewGlassECXYDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSFRAMETYPE:
                        return { ...state, SetupOpticProcedureNewGlassFrameTypeList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSFRAMETYPE:
                        return { ...state, SetupOpticProcedureNewGlassFrameTypeSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSFRAMETYPE:
                        return { ...state, SetupOpticProcedureNewGlassFrameTypeUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSFRAMETYPE:
                        return { ...state, SetupOpticProcedureNewGlassFrameTypeDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSBRAND:
                        return { ...state, SetupOpticProcedureNewGlassBrandList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSBRAND:
                        return { ...state, SetupOpticProcedureNewGlassBrandSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSBRAND:
                        return { ...state, SetupOpticProcedureNewGlassBrandUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSBRAND:
                        return { ...state, SetupOpticProcedureNewGlassBrandDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSCIRCUM:
                        return { ...state, SetupOpticProcedureNewGlassCircumList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSCIRCUM:
                        return { ...state, SetupOpticProcedureNewGlassCircumSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSCIRCUM:
                        return { ...state, SetupOpticProcedureNewGlassCircumUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSCIRCUM:
                        return { ...state, SetupOpticProcedureNewGlassCircumDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSECXZ:
                        return { ...state, SetupOpticProcedureNewGlassECXZList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSECXZ:
                        return { ...state, SetupOpticProcedureNewGlassECXZSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSECXZ:
                        return { ...state, SetupOpticProcedureNewGlassECXZUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSECXZ:
                        return { ...state, SetupOpticProcedureNewGlassECXZDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSCOLLECTION:
                        return { ...state, SetupOpticProcedureNewGlassCollectionList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSCOLLECTION:
                        return { ...state, SetupOpticProcedureNewGlassCollectionSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSCOLLECTION:
                        return { ...state, SetupOpticProcedureNewGlassCollectionUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSCOLLECTION:
                        return { ...state, SetupOpticProcedureNewGlassCollectionDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSFRAMEED:
                        return { ...state, SetupOpticProcedureNewGlassFrameEDList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSFRAMEED:
                        return { ...state, SetupOpticProcedureNewGlassFrameEDSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEED:
                        return { ...state, SetupOpticProcedureNewGlassFrameEDUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSFRAMEED:
                        return { ...state, SetupOpticProcedureNewGlassFrameEDDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSREAD:
                        return { ...state, SetupOpticProcedureNewGlassReadList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSREAD:
                        return { ...state, SetupOpticProcedureNewGlassReadSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSREAD:
                        return { ...state, SetupOpticProcedureNewGlassReadUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSREAD:
                        return { ...state, SetupOpticProcedureNewGlassReadDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSFRAMECOLOR:
                        return { ...state, SetupOpticProcedureNewGlassFrameColorList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSFRAMECOLOR:
                        return { ...state, SetupOpticProcedureNewGlassFrameColorSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSFRAMECOLOR:
                        return { ...state, SetupOpticProcedureNewGlassFrameColorUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSFRAMECOLOR:
                        return { ...state, SetupOpticProcedureNewGlassFrameColorDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSPANTO:
                        return { ...state, SetupOpticProcedureNewGlassPantoList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSPANTO:
                        return { ...state, SetupOpticProcedureNewGlassPantoSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSPANTO:
                        return { ...state, SetupOpticProcedureNewGlassPantoUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSPANTO:
                        return { ...state, SetupOpticProcedureNewGlassPantoDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSHEADCAPE:
                        return { ...state, SetupOpticProcedureNewGlassHeadCapeList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSHEADCAPE:
                        return { ...state, SetupOpticProcedureNewGlassHeadCapeSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSHEADCAPE:
                        return { ...state, SetupOpticProcedureNewGlassHeadCapeUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSHEADCAPE:
                        return { ...state, SetupOpticProcedureNewGlassHeadCapeDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSFRAMEDETAILMATERIAL:
                        return { ...state, SetupOpticProcedureNewGlassFrameDetailMaterialList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSFRAMEDETAILMATERIAL:
                        return { ...state, SetupOpticProcedureNewGlassFrameDetailMaterialSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEDETAILMATERIAL:
                        return { ...state, SetupOpticProcedureNewGlassFrameDetailMaterialUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSFRAMEDETAILMATERIAL:
                        return { ...state, SetupOpticProcedureNewGlassFrameDetailMaterialDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSFRAMEFIT:
                        return { ...state, SetupOpticProcedureNewGlassFrameFitList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSFRAMEFIT:
                        return { ...state, SetupOpticProcedureNewGlassFrameFitSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEFIT:
                        return { ...state, SetupOpticProcedureNewGlassFrameFitUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSFRAMEFIT:
                        return { ...state, SetupOpticProcedureNewGlassFrameFitDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSCORRIDORR:
                        return { ...state, SetupOpticProcedureNewGlassCorridorRList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSCORRIDORR:
                        return { ...state, SetupOpticProcedureNewGlassCorridorRSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSCORRIDORR:
                        return { ...state, SetupOpticProcedureNewGlassCorridorRUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSCORRIDORR:
                        return { ...state, SetupOpticProcedureNewGlassCorridorRDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSWRAPANGLE:
                        return { ...state, SetupOpticProcedureNewGlassWrapAngleList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSWRAPANGLE:
                        return { ...state, SetupOpticProcedureNewGlassWrapAngleSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSWRAPANGLE:
                        return { ...state, SetupOpticProcedureNewGlassWrapAngleUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSWRAPANGLE:
                        return { ...state, SetupOpticProcedureNewGlassWrapAngleDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSCORRIDORL:
                        return { ...state, SetupOpticProcedureNewGlassCorridorLList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSCORRIDORL:
                        return { ...state, SetupOpticProcedureNewGlassCorridorLSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSCORRIDORL:
                        return { ...state, SetupOpticProcedureNewGlassCorridorLUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSCORRIDORL:
                        return { ...state, SetupOpticProcedureNewGlassCorridorLDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURENEWGLASSFRAMESTATUS:
                        return { ...state, SetupOpticProcedureNewGlassFrameStatusList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURENEWGLASSFRAMESTATUS:
                        return { ...state, SetupOpticProcedureNewGlassFrameStatusSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURENEWGLASSFRAMESTATUS:
                        return { ...state, SetupOpticProcedureNewGlassFrameStatusUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURENEWGLASSFRAMESTATUS:
                        return { ...state, SetupOpticProcedureNewGlassFrameStatusDeleteStatus: action.payload.success, }

                case GETSETUPOPTICPROCEDURESURGERYPROCUDEURETYPE:
                        return { ...state, SetupOpticProcedureSurgeryProcedureTypeList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURESURGERYPROCUDEURETYPE:
                        return { ...state, SetupOpticProcedureSurgeryProcedureTypeSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURESURGERYPROCUDEURETYPE:
                        return { ...state, SetupOpticProcedureSurgeryProcedureTypeUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURESURGERYPROCUDEURETYPE:
                        return { ...state, SetupOpticProcedureSurgeryProcedureTypeDeleteStatus: action.payload.success, }
                case GETSETUPOPTICPROCEDURESURGERYPROCUDEURENAME:
                        return { ...state, SetupOpticProcedureSurgeryProcedureNameList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURESURGERYPROCUDEURENAME:
                        return { ...state, SetupOpticProcedureSurgeryProcedureNameSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURESURGERYPROCUDEURENAME:
                        return { ...state, SetupOpticProcedureSurgeryProcedureNameUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURESURGERYPROCUDEURENAME:
                        return { ...state, SetupOpticProcedureSurgeryProcedureNameDeleteStatus: action.payload.success, }
                case GETSETUPOPTICPROCEDURELASIKSURGERYPOWERUSED:
                        return { ...state, SetupOpticProcedureLasikSurgeryPowerUsedList: action.payload.data, }
                case CREATESETUPOPTICPROCEDURELASIKSURGERYPOWERUSED:
                        return { ...state, SetupOpticProcedureLasikSurgeryPowerUsedSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICPROCEDURELASIKSURGERYPOWERUSED:
                        return { ...state, SetupOpticProcedureLasikSurgeryPowerUsedUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICPROCEDURELASIKSURGERYPOWERUSED:
                        return { ...state, SetupOpticProcedureLasikSurgeryPowerUsedDeleteStatus: action.payload.success, }
                case GETSETUPOPTICVISIONEYECHARTDISTANCE:
                        return { ...state, SetupOpticEyeChartDistanceList: action.payload.data, }
                case CREATESETUPOPTICVISIONEYECHARTDISTANCE:
                        return { ...state, SetupOpticEyeChartDistanceSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICVISIONEYECHARTDISTANCE:
                        return { ...state, SetupOpticEyeChartDistanceUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICVISIONEYECHARTDISTANCE:
                        return { ...state, SetupOpticEyeChartDistanceDeleteStatus: action.payload.success, }
                case GETSETUPOPTICVISIONEYECHARTNEAR:
                        return { ...state, SetupOpticEyeChartNearList: action.payload.data, }
                case CREATESETUPOPTICVISIONEYECHARTNEAR:
                        return { ...state, SetupOpticEyeChartNearSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICVISIONEYECHARTNEAR:
                        return { ...state, SetupOpticEyeChartNearUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICVISIONEYECHARTNEAR:
                        return { ...state, SetupOpticEyeChartNearDeleteStatus: action.payload.success, }
                case GETSETUPOPTICVISIONEYECHARTSPHERICAL:
                        return { ...state, SetupOpticEyeChartSphericalList: action.payload.data, }
                case CREATESETUPOPTICVISIONEYECHARTSPHERICAL:
                        return { ...state, SetupOpticEyeChartSphericalSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICVISIONEYECHARTSPHERICAL:
                        return { ...state, SetupOpticEyeChartSphericalUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICVISIONEYECHARTSPHERICAL:
                        return { ...state, SetupOpticEyeChartSphericalDeleteStatus: action.payload.success, }
                case GETSETUPOPTICVISIONEYECHARTCYLINDERICAL:
                        return { ...state, SetupOpticEyeChartCylindericalList: action.payload.data, }
                case CREATESETUPOPTICVISIONEYECHARTCYLINDERICAL:
                        return { ...state, SetupOpticEyeChartCylindericalSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICVISIONEYECHARTCYLINDERICAL:
                        return { ...state, SetupOpticEyeChartCylindericalUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICVISIONEYECHARTCYLINDERICAL:
                        return { ...state, SetupOpticEyeChartCylindericalDeleteStatus: action.payload.success, }
                case GETSETUPOPTICVISIONEYECHARTAXIS:
                        return { ...state, SetupOpticEyeChartAxisList: action.payload.data, }
                case CREATESETUPOPTICVISIONEYECHARTAXIS:
                        return { ...state, SetupOpticEyeChartAxisSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICVISIONEYECHARTAXIS:
                        return { ...state, SetupOpticEyeChartAxisUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICVISIONEYECHARTAXIS:
                        return { ...state, SetupOpticEyeChartAxisDeleteStatus: action.payload.success, }
                case GETSETUPOPTICVISIONEYECHARTDIAMETER:
                        return { ...state, SetupOpticEyeChartDiameterList: action.payload.data, }
                case CREATESETUPOPTICVISIONEYECHARTDIAMETER:
                        return { ...state, SetupOpticEyeChartDiameterSaveStatus: action.payload.success, }
                case UPDATESETUPOPTICVISIONEYECHARTDIAMETER:
                        return { ...state, SetupOpticEyeChartDiameterUpdateStatus: action.payload.success, }
                case DELETESETUPOPTICVISIONEYECHARTDIAMETER:
                        return { ...state, SetupOpticEyeChartDiameterDeleteStatus: action.payload.success, }


                default:
                        return state
        }
}                                        